/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconClockFilled extends React.Component {
  render() {
    const iconClasses = classNames(
      "icon clock icon-filled",
      this.props.className
    );

    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,16H7.995 C7.445,16,7,15.555,7,15.005v-0.011C7,14.445,7.445,14,7.995,14H14V5.995C14,5.445,14.445,5,14.995,5h0.011 C15.555,5,16,5.445,16,5.995V16z" />
      </svg>
    );
  }
}

IconClockFilled.defaultProps = {
  className: null
};

IconClockFilled.propTypes = {
  className: PropTypes.string
};

export default IconClockFilled;
